import Vue from 'vue'
import NavBar from './navbar'
import FpBlock from './fp-block'
import Wishlist from './wishlist'
import PlusMinus from './plus-minus'

Vue.component('navbar', NavBar)
Vue.component('fp-block', FpBlock)
Vue.component('wishlist', Wishlist)
Vue.component('plus-minus', PlusMinus)